import { QueryClient, QueryCache, MutationCache } from "@tanstack/react-query";
import { onErrorShow } from "@utils/onErrorShow";
import { messageFor, errorScope } from "@lib/errors";
import type { ErrorMeta } from "@lib/errors";

declare module "@tanstack/react-query" {
  interface Register {
    mutationMeta: ErrorMeta;
    queryMeta: { entity?: ErrorMeta["entity"] };
  }
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
  queryCache: new QueryCache({
    onError: (error, query) => {
      const entity = query.meta?.entity;
      if (entity) {
        const msg = messageFor(entity, "fetch", error);
        onErrorShow(`${msg} [${errorScope(entity, "fetch")}]`);
      } else {
        const fallback =
          error instanceof Error ? error.message : "Failed to load data";
        onErrorShow(fallback);
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error, _vars, _ctx, mutation) => {
      const meta = mutation.meta;
      if (!meta?.entity || !meta.action) return;
      const msg = messageFor(meta.entity, meta.action, error);
      onErrorShow(`${msg} [${errorScope(meta.entity, meta.action)}]`);
    },
  }),
});
